<template>
    <div>
        <MenuPurchase/>
        <SupplierAdd/>
    </div>
</template>

<script>
    import MenuPurchase from "@/components/admin/purchase/menupurchase/MenuPurchase.vue";
    import SupplierAdd from "@/components/admin/purchase/SupplierAdd.vue";

    export default {
        name: "Supplier",
        components: {
            MenuPurchase,
            SupplierAdd,
        }
    }
</script>

<style scoped>

</style>
